// @flow
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';

export const VideoBlock = styled.div`
  margin-bottom: 32px;

  > div {
    margin: 0 auto;
    width: 100%;
    max-width: ${grid(6)}px;
  }

  iframe {
    border-radius: 8px;
  }
`;

export const BodyInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  ${minMediaQueries.desktop`
    padding: 0 40px;
  `};
`;
